import SnapGoogleAnalytics from "./SnapGoogleAnalytics";
import SnapPixelAnalytics from "./SnapPixelAnalytics";

class SnapAnalytics {
  /**
    @param {String} entityId - id of entity
    @param {Object} analytics - The analytics to be used, has the shape of
    @param {String} analytics.creds - creds to pass to the analytics engine
    @param {String} [analytics.trackerName] - optional tracker name
 */
  constructor(entityId, analytics = {}) {
    this.entityId = entityId;
    this.analytics = analytics;
    this.listeners = [];
    this.setup();
  }

  setup() {
    if (this.analytics && typeof this.analytics === "object") {
      Object.entries(this.analytics).forEach(([analytic, { creds, trackerName }]) => {
        this.generate(analytic, { creds, trackerName });
      });
    }
  }

  generate(analytic, { creds, trackerName }) {
    switch (analytic) {
      case "google_analytics": {
        this.listeners.push(new SnapGoogleAnalytics({ creds, trackerName }));
        return;
      }
      case "pixel_analytics": {
        this.listeners.push(new SnapPixelAnalytics({ creds, trackerName }));
        return;
      }
      default: {
        console.error("unsupported analytic");
      }
    }
  }

  /**
    @param {function} funcName - function name to be called
    @param {Object} [payload] - option payload for method call
  */
  callListenerMethod(funcName, payload = {}) {
    // dont track stuff for amplo u
    if (this.entityId !== "57069316a7785f19b8000006") {
      this.listeners.forEach((listener) => {
        if (listener[funcName] && typeof listener[funcName] === "function") {
          listener[funcName](payload);
        }
      });
    }
  }

  /**
  @param {Object} payload
  @param {String} payload.id - id of transaction
  @param {Array}  payload.items - array like list of immutable objects
  @param {String} payload.revenue - sum of item amounts
  */
  addTransaction(payload = {}) {
    this.callListenerMethod("addTransaction", payload);
  }

  /**
    @param {Object} payload
    @param {String} payload.id - id of added item
    @param {String} payload.name - name of item
    @param {String} payload.price - price of item
  */
  addItem(payload = {}) {
    this.callListenerMethod("addItem", payload);
  }

  /**
    Send analytics
  */
  send(payload = {}) {
    this.callListenerMethod("send", payload);
  }

  /**
    Clear cart in analytics
  */
  clear() {
    this.callListenerMethod("clear");
  }

  /**
    Track event
    @param payload
    @param [payload.hitType] - Type of hit, e.g. transaction, click, event
    @param [payload.eventCategory] - Category of event
    @param [payload.eventLabel] - label of event
    @param [payload.eventAction] - type of interaction
  */
  track(payload = {}) {
    this.callListenerMethod("track", payload);
  }
  /**
    Tracks when payment info is entered
  */
  paymentInfo() {
    this.callListenerMethod("paymentInfo");
  }
}

export default SnapAnalytics;
